// extracted by mini-css-extract-plugin
export var caption = "Image-module--caption--7SwR4";
export var component = "Image-module--component--b4Thr";
export var credit = "Image-module--credit--ZoeGH";
export var link = "Image-module--link--2tV2g";